export function calculatePercentilAlturaUterina(semanasGestacao: number, percentil: 10 | 90) {
  return percentil === 10
    ? -0.0068839207 * (semanasGestacao * semanasGestacao) + 1.23239022 * semanasGestacao - 6.9606459
    : -0.0139899373 * (semanasGestacao * semanasGestacao) + 1.55868069 * semanasGestacao - 4.6141899
}
